import { get } from 'lodash-es';

class ProviderHelperServiceClass {
  getSellerLabelProviderDefaultName(sellerLabelProvider, labelProviders, sellerLabelProviders) {
    if (!sellerLabelProvider) {
      return '';
    }

    const hasMultiples =
      sellerLabelProviders.filter((provider) => provider.labelProviderId === sellerLabelProvider.labelProviderId).length > 1;
    const matchingLabelProvider = labelProviders.find((provider) => provider.labelProviderId === sellerLabelProvider.labelProviderId);

    const matchingLabelProviderName = get(matchingLabelProvider, 'name', '');
    const sellerLabelProviderAccountNumber = get(sellerLabelProvider, 'accountNumber', '');

    if (!hasMultiples) {
      return matchingLabelProviderName;
    }
    return `${matchingLabelProviderName} (${sellerLabelProviderAccountNumber})`;
  }

  // hook available in hooks/use-get-seller-provider-name
  getSellerLabelProviderName(sellerLabelProvider, labelProviders, sellerLabelProviders) {
    if (!sellerLabelProvider) {
      return '';
    }
    if (!sellerLabelProvider.name) {
      return this.getSellerLabelProviderDefaultName(sellerLabelProvider, labelProviders, sellerLabelProviders);
    }

    const matchingLabelProvider = labelProviders.find((provider) => provider.labelProviderId === sellerLabelProvider.labelProviderId);
    const matchingLabelProviderName = get(matchingLabelProvider, 'name', '');

    return `${matchingLabelProviderName} - ${sellerLabelProvider.name}`;
  }
}

export const ProviderHelperService = new ProviderHelperServiceClass();
